<template>
  <div class="content-block">
    <div class="asd-form-section">
      <div class="section-title">
        <h5>
          <i class="fas fa-copy"></i>
          Samba
        </h5>
        <div class="section-title-controls">
          <ActiveButton class="asd-btn-confirm"
                        :click="save"
          >
            <i class="fas fa-save"></i>
          </ActiveButton>
        </div>
      </div>
      <div style="margin: 10px">
        <div v-if="!enabled"
             class="alert alert-warning"
             role="alert"
        >
          Samba modul je vypnutý
        </div>
        <div class="samba-settings-grid">
          <div>
            <label>Projekty</label>
            <UIProjectTypeSelect v-model="projectTypes"></UIProjectTypeSelect>
          </div>
          <div>
            <label>Úkoly'</label>
            <UITaskTypeSelect v-model="taskTypes"></UITaskTypeSelect>
          </div>
          <div>
            <label>Zapnuto</label>
            <div>
              <UISwitch v-model="enabled"></UISwitch>
            </div>
          </div>
          <div>
            <label>Výchozí oprávění</label>
            <Multiselect
              v-model="defaultRW"
              valueByPath="id"
              label="label"
              :returnAsSingle="true"
              :allowEmpty="false"
              :max="1"
              :options="defaultRWOptions"
            >
            </Multiselect>
          </div>
        </div>
      </div>

      <div style="margin: 10px">
        <table>
          <tr v-for="pt in projectOverrides"
              :key="pt.projectType.id"
              style="margin-top: 10px"
          >
            <td>
              <router-link :to="{ name: 'settingsSambaFolders', params: { id: pt.projectType.id } }">
                <button class="asd-btn-confirm"
                        style="margin-right: 10px"
                >
                  nastavit složky pro {{ pt.projectType.name }}
                </button>
              </router-link>
            </td>
            <td>
              <span v-if="pt.folders === null"
                    style="color: silver"
              >Nenastaveno</span>
              <span v-else
                    style="color: green"
              >Nastaveno</span>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { map, get, cloneDeep, has } from 'lodash'
import UISwitch from 'CORE/components/utilities/ui-switch'
import UIProjectTypeSelect from 'CORE/components/utilities/ui-project-type-select'
import UITaskTypeSelect from 'CORE/components/utilities/ui-task-type-select'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import ActiveButton from 'CORE/components/form/active-button'

const DEFAULT_FOLDER = { name: 'Název složky', children: [] }

export default {
    name: 'SambaGlobalSettings',
    components: {
        UISwitch,
        UIProjectTypeSelect,
        UITaskTypeSelect,
        Multiselect,
        ActiveButton,
    },
    data() {
        return {
            enabled: false,
            projectTypes: [],
            taskTypes: [],
            defaultRW: '',
            rootFolder: {},
        }
    },
    computed: {
        projectOverrides() {
            return map(this.projectTypes, pt => {
                return {
                    projectType: this.$store.getters.projectTypeById(pt),
                    folders: get(this.$store.getters.settings, `files.overrides.${pt}`, null),
                }
            })
        },
        defaultRWOptions() {
            return [
                { id: '', label: 'nic' },
                { id: 'r', label: 'čtení' },
                { id: 'rw', label: 'čtení a zápis' },
            ]
        },
    },
    created() {
        const settings = get(this.$store.getters.currentUser, 'company.settings.files', {})
        this.enabled = get(settings, 'enabled', false)
        this.projectTypes = get(settings, 'projectTypes', [])
        this.taskTypes = get(settings, 'taskTypes', [])
        this.defaultRW = get(settings, 'defaultRW', '')
        this.rootFolder = get(settings, 'rootFolder', cloneDeep(DEFAULT_FOLDER))
    },
    methods: {
        async save() {
            try {
                const data = this.$store.getters.settings
                if (!has(data, 'files')) {
                    this.$set(data, 'files', {})
                }
                data['files']['enabled'] = this.enabled
                data['files']['projectTypes'] = this.projectTypes
                data['files']['taskTypes'] = this.taskTypes
                data['files']['defaultRW'] = this.defaultRW
                data['files']['rootFolder'] = this.rootFolder

                await this.$store.dispatch('saveCurrentUserCompanySettings', data)
                this.flash('Uloženo', 'success', {
                    timeout: 1500,
                })
                this.$emit('done')
            } catch (e) {
                this.flash(`Nepovedlo se [${e.message}]`, 'error')
                throw e
            }
        },
    },
}
</script>

<style lang="scss">
.samba-settings-grid {
    display: grid;
    grid-auto-rows: minmax(60px, auto);
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 5px 20px;
}
</style>
